import { baseURL } from '..';
import { IDrainPipe } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetDrainPipePreviewResponse } from './iApiResponse';

const drainPipeProvider = () => {
    const getDrainPipeByIdAsync = async (id: number): Promise<IResponse<IDrainPipe>> => httpClient.getAsync(createRequest(baseURL, `/DrainPipe/GetDrainPipe?id=${id}`), createHeaders());

    const updateDrainPipeAsync = async (payload: IDrainPipe): Promise<IResponse<IDrainPipe>> => httpClient.putAsync(createRequest(baseURL, '/DrainPipe/UpdateDrainPipe', payload), createHeaders());

    const insertDrainPipeAsync = async (payload: IDrainPipe): Promise<IResponse<IDrainPipe>> => httpClient.postAsync(createRequest(baseURL, '/DrainPipe/InsertDrainPipe', payload), createHeaders());

    const getPaginatedDrainPipePreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetDrainPipePreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/DrainPipe/GetPaginatedDrainPipePreviews', undefined, paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const getDrainPipeForCountryAsync = async (country: string): Promise<IResponse<IDrainPipe[]>> =>
        httpClient.getAsync(createRequest(baseURL, `/DrainPipe/GetDrainPipeForCountry?country=${country}`), createHeaders());

    return {
        getPaginatedDrainPipePreviewsAsync,
        getDrainPipeByIdAsync,
        updateDrainPipeAsync,
        insertDrainPipeAsync,
        getDrainPipeForCountryAsync
    };
};

export default drainPipeProvider();
